import React, { useEffect, useRef } from 'react';
import { ACCOUNT_MODAL } from '@constants';
import EVENTS from '@constants/events';
import { connect } from 'react-redux';
import { handleOpenModalAction } from '@Header/Modals/ducks/operations';
import { closeCurrentModal, getUserProfile } from '@Header/ducks/operations';
import { closeSupportDropdown } from './SupportDropdown/ducks/operations';

const formatEventForNewAccountModal = (event, tab) => ({
  ...event,
  detail: {
    ...event?.detail,
    tab,
    [tab]: {
      modalHeading: event?.detail?.modalHeading,
      modalTitle: event?.detail?.modalTitle,
      submitButtonText: event?.detail?.submitButtonText,
    }
  }
});

const component = props => {
  const $el = useRef(null);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      const e = formatEventForNewAccountModal(event, 'signIn');
      props.handleOpenModalAction(ACCOUNT_MODAL, e);
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.OPEN, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.OPEN, handler);
  }, [$el, props.handleOpenModalAction]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      props.closeModal();
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.CLOSE, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.CLOSE, handler);
  }, [$el, props.closeModal]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      const e = formatEventForNewAccountModal(event, 'createAccount');
      props.handleOpenModalAction(ACCOUNT_MODAL, e);
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.CREATE_ACCOUNT, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.CREATE_ACCOUNT, handler);
  }, [$el, props.handleOpenModalAction]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      const e = formatEventForNewAccountModal(event, 'signIn');
      props.handleOpenModalAction(ACCOUNT_MODAL, formatEventForNewAccountModal(event, 'signIn'));
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.SIGN_IN, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.SIGN_IN, handler);
  }, [$el, props.handleOpenModalAction]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      props.handleOpenModalAction(ACCOUNT_MODAL, formatEventForNewAccountModal(event, 'forgotPassword'));
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.FORGOT_PASSWORD, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.FORGOT_PASSWORD, handler);
  }, [$el, props.handleOpenModalAction]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      props.handleOpenModalAction(ACCOUNT_MODAL, formatEventForNewAccountModal(event, 'resetPassword'));
    };
    $el.current.addEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.RESET_PASSWORD, handler);
    return () => $el.current.removeEventListener(EVENTS.ACCOUNT_MODAL.GO_TO_TAB.RESET_PASSWORD, handler);
  }, [$el, props.handleOpenModalAction]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      props.closeSupportDropdown();
    };
    $el.current.addEventListener(EVENTS.SUPPORT_DROP_DOWN.CLOSE, handler);
    return () => $el.current.removeEventListener(EVENTS.SUPPORT_DROP_DOWN.CLOSE, handler);
  }, [$el, props.closeSupportDropdown]);

  useEffect(() => {
    const handler = event => {
      event.preventDefault();
      props.getUserProfile();
    };
    $el.current.addEventListener(EVENTS.AUTH.FETCH_PROFILE, handler);
    return () => $el.current.removeEventListener(EVENTS.AUTH.FETCH_PROFILE, handler);
  }, [$el, props.getUserProfile]);
  return <div ref={$el} id="header-plugin-events" />;
};

const mapDispatchToProps = dispatch => ({
  handleOpenModalAction: (name, event) => dispatch(handleOpenModalAction(name, event)),
  closeModal: () => dispatch(closeCurrentModal()),
  closeSupportDropdown: () => dispatch(closeSupportDropdown()),
  getUserProfile: () => dispatch(getUserProfile())
});

export const JavascriptEventing = connect(null, mapDispatchToProps)(component);
